<template>
  <div class="select-form" :class="{'one-btn':hiddenExport,'isopen':isopen,'showSwtich':showSwtich}">
    <slot></slot>
    <el-button class="cxbt" @click="queryOrderlList">查询</el-button>
    <el-button class="dc-btn" @click="exportPolicy" plain v-if="!hiddenExport"
      >导出</el-button
    >
    <div class="xl-item" v-if="showSwtich">
      <template v-if="!isopen">
        <i class="el-icon-arrow-down"></i>
        <span @click="isopen=true" v-if="!isopen" >展开查询</span>
      </template>
      <template v-else>
        <i class="el-icon-arrow-up"></i>
        <span @click="isopen=false" >收起查询</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["hiddenExport","showSwtich"],
  data() {
    return {
      isopen:false
    };
  },
  watch: {},
  computed: {},
  methods: {
    queryOrderlList() {
      this.$emit("search");
    },
    exportPolicy() {
      this.$emit("export");
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "./topSearchForm.scss";
</style>
